const CANHOTO_IMAGE_MIME_BY_EXT = {
  jpg: 'image/jpeg',
  jpeg: 'image/jpeg',
  png: 'image/png',
  gif: 'image/gif',
  webp: 'image/webp',
  bmp: 'image/bmp'
};

export const buildCanhotoPreviewSrc = (arquivo, extensao) => {
  const base64 = String(arquivo || '').trim();
  if (!base64) return null;

  if (base64.startsWith('data:')) {
    return base64;
  }

  const ext = String(extensao || '')
    .trim()
    .replace(/^\./, '')
    .toLowerCase();
  const mime = CANHOTO_IMAGE_MIME_BY_EXT[ext];
  if (!mime) return null;

  return `data:${mime};base64,${base64}`;
};

export const readFileAsBase64 = (file) => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.onload = () => {
    const result = String(reader.result || '');
    const base64 = result.includes(',') ? result.split(',').pop() : result;
    resolve(base64 || '');
  };
  reader.onerror = (error) => reject(error);
  reader.readAsDataURL(file);
});

export const buildAnexosPayload = async (files) => {
  const anexos = Array.isArray(files) ? files : Array.from(files || []);
  const payload = await Promise.all(
    anexos.map(async (file) => ({
      Base64: await readFileAsBase64(file),
      NomeArquivo: file.name,
      ContentType: file.type || 'application/octet-stream'
    }))
  );

  return payload.filter((item) => item.Base64);
};
